import React, { useEffect, useState } from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";

import { useCustomerContext } from "../context/CustomerContext";
import { Loading } from "../components/general/Loading";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { fetchAuthSession } from "aws-amplify/auth";

const StaffPage = () => {
    const { customerAttributes, loading } = useCustomerContext();
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);
    const [isStaff, setIsStaff] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (authStatus === "unauthenticated" || isStaff === false) {
            navigate("/");
        } else {
            fetchAuthSession().then((session) => {
                const idTokenPayload = session.tokens.idToken.payload;
                if ("cognito:groups" in idTokenPayload) {
                    if (idTokenPayload["cognito:groups"].includes("Staff")) {
                        setIsStaff(true);
                    } else {
                        setIsStaff(false);
                    }
                }
            });
        }
    }, [isStaff, authStatus, navigate]);

    if (loading) {
        return <Loading />;
    }
    return (
        <Box p={8}>
            <VStack spacing={8} align="center">
                <Heading as="h1" size="2xl">
                    Welcome, {customerAttributes.given_name}!
                </Heading>
                <Text fontSize="xl">
                    Thank you for your hard work and dedication.
                </Text>
                <Box display="flex" flexDirection="column" gap={4}>
                    <Button
                        as={Link}
                        to="/create-session"
                        colorScheme="blue"
                        size="lg"
                    >
                        Create a Session
                    </Button>
                    <Button
                        as={Link}
                        to="/check-in"
                        colorScheme="green"
                        size="lg"
                    >
                        Check In a Customer
                    </Button>
                </Box>
            </VStack>
        </Box>
    );
};

export default StaffPage;
